module.exports = __webpack_public_path__ + "img/181.ecd41a85.jpg";